import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';

const feathersClient = feathers().configure(
  rest()
    .fetch(window.fetch)
);

export default feathersClient;
